module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedExtraLight.39099f0.ttf";